// extracted by mini-css-extract-plugin
module.exports = {"Text":"Header_Text__30KtJ"};